import { Motion } from '@legendapp/motion';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { Easing, StyleSheet } from 'react-native';

import { useSeenThingsPresenter } from '../SeenThingsPresenter';

const ANIMATION_DURATION = 300;

type Props = {
  children?: ReactNode;
  type: 'brand' | 'detail';
};

export const SeenThingsAnimatedWrapper = observer(
  function SeenThingsAnimatedWrapper({ children, type }: Props) {
    const { animationStates, brandAnimation, detailAnimation } =
      useSeenThingsPresenter();

    const brandState = brandAnimation.value
      ? animationStates.brand.animate
      : animationStates.brand.initial;

    const detailState = detailAnimation.value
      ? animationStates.detail.animate
      : animationStates.detail.initial;

    return (
      <Motion.View
        style={styles.wrapper}
        key='brand-and-detail-animated-view' // Required for legend motion package to animate properly
        animate={type === 'brand' ? brandState : detailState}
        transition={{
          duration: ANIMATION_DURATION,
          type: 'timing',
          easing: Easing.inOut(Easing.ease),
        }}
      >
        {children}
      </Motion.View>
    );
  }
);

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    width: '100%',
  },
});
